import { render, staticRenderFns } from "./InsucessosHome.vue?vue&type=template&id=21ff92d6"
import script from "./InsucessosHome.vue?vue&type=script&lang=js"
export * from "./InsucessosHome.vue?vue&type=script&lang=js"
import style0 from "./InsucessosHome.vue?vue&type=style&index=0&id=21ff92d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports